import React from 'react'

import TourPageCategoryTile from './TourPageCategoryTile'

import Heading from 'components/Luxkit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import FullWidthCarousel from 'components/Luxkit/Carousel/FullWidthCarousel'

const CATEGORIES: Tours.CategoryData[] = [
  {
    name: 'Small Groups',
    subText: 'Travel with up to 24 people',
    imageId: 'tour-category-tile-small-group',
    parameterName: 'isSmallGroup',
    parameterValue: true,
  },
  {
    name: 'Private Requests Available',
    subText: 'Travel exclusively, when it works for you',
    imageId: 'tour-category-tile-private',
    parameterName: 'isPrivateRequest',
    parameterValue: true,
  },
  {
    name: 'Food & Culinary',
    subText: 'Taste your way around the world',
    imageId: 'tour-category-tile-food',
    parameterName: 'categories',
    parameterValue: ['foodandculinarytours'],
  },
  {
    name: 'Rail Journeys',
    subText: 'All aboard to see the sights',
    imageId: 'tour-category-tile-rail-journeys',
    parameterName: 'categories',
    parameterValue: ['railjourneys'],
  },
  {
    name: 'Cultural',
    subText: 'See the sights & dive into culture',
    imageId: 'tour-category-tile-cultural',
    parameterName: 'categories',
    parameterValue: ['culturaltours'],
  },
  {
    name: 'Wildlife Safari',
    subText: 'Roam amongst diverse landscapes & wildlife',
    imageId: 'tour-category-tile-wildlife',
    parameterName: 'categories',
    parameterValue: ['wildlifesafaris'],
  },
  {
    name: 'UltraLux',
    subText: 'Enjoy ultimate luxury',
    imageId: 'tour-category-tile-ultra-lux',
    parameterName: 'productTypes',
    parameterValue: 'ultra_lux_tour',
  },
  {
    name: 'Lux Exclusive',
    subText: 'Exclusive to Luxury Escapes',
    imageId: 'tour-category-tile-lux-exclusive',
    parameterName: 'categories',
    parameterValue: ['luxexclusive'],
  },
  {
    name: 'Family Friendly',
    subText: 'Adventures for the whole family',
    imageId: 'tour-category-tile-family',
    parameterName: 'isFamilyFriendly',
    parameterValue: true,
  },
  {
    name: 'Hiking, Cycling & Adventure',
    subText: 'Explore the great outdoors',
    imageId: 'tour-category-tile-adventure',
    parameterName: 'categories',
    parameterValue: ['hikingcyclingandadventure'],
  },
  {
    name: 'Festivals & Events',
    subText: "Don't miss out on life's best moments",
    imageId: 'tour-category-tile-festival',
    parameterName: 'categories',
    parameterValue: ['festivalsandevents'],
  },
  {
    name: 'Sailing',
    subText: 'Hop on board to explore the seas',
    imageId: 'tour-category-tile-sailing',
    parameterName: 'categories',
    parameterValue: ['sailing'],
  },
  {
    name: 'Health & Wellness',
    subText: 'Relax & rejuvenate',
    imageId: 'tour-category-tile-health',
    parameterName: 'categories',
    parameterValue: ['healthandwellness'],
  },
]

function TourPageCategoriesCarousel() {
  return <VerticalSpacer gap={20}>
    <LayoutContainer>
      <Heading variant="heading2">Explore <i>your</i> way</Heading>
    </LayoutContainer>
    <FullWidthCarousel snap="start" itemsPerArrow={6}>
      {CATEGORIES.length > 0 && <>
        {CATEGORIES.map(category => <TourPageCategoryTile
          key={category.name}
          category={category}
        />)}
      </>}
    </FullWidthCarousel>
  </VerticalSpacer>
}

export default React.memo(TourPageCategoriesCarousel)
